export default __webpack_public_path__ + "static/media/Resume.104bc140.pdf";